import { type FC, type PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'
import { DELTA_TRIAL_FEATURES } from '../../Plan/DeltaTrial/DeltaTrialFeatures'
import { Upsell } from '../../Plan/DeltaTrial/Upsell/Upsell'
import { useAccountOpeningConnectors } from '../hooks/useAccountOpeningConnectors'
import { useAccountOpeningQuota } from '../hooks/useAccountOpeningQuota'

export const AccountOpeningGate: FC<PropsWithChildren> = ({ children }) => {
  const { enabled, isLoading: isQuotaLoading } = useAccountOpeningQuota()
  const { hasAny, isLoading: isConnectorsLoading } = useAccountOpeningConnectors()

  if (isQuotaLoading) {
    return null
  }
  if (!enabled) {
    return <Upsell feature={DELTA_TRIAL_FEATURES['accountOpening']} />
  }
  if (isConnectorsLoading) {
    return null
  }
  if (!hasAny) {
    return <Navigate to='/library/manage-contacts' replace />
  }
  return <>{children}</>
}
